import { useEffect } from "react";

const DEFAULT_DESC =
    "The Aegis Line is a disciplined AI day-trading engine for stocks and futures. Deterministic analysis, transparent decisions, computed risk — and a methodology held to a standard that doesn't bend for a single trade.";

function setMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

// Lightweight per-page SEO: title + description + OG tags.
export default function Seo({ title, description }) {
    useEffect(() => {
        const fullTitle = title
            ? `${title} · The Aegis Line`
            : "The Aegis Line — The line holds.";
        const desc = description || DEFAULT_DESC;
        document.title = fullTitle;
        setMeta("name", "description", desc);
        setMeta("property", "og:title", fullTitle);
        setMeta("property", "og:description", desc);
    }, [title, description]);

    return null;
}
